interface InfoRowProps {
  label: string;
  value?: string | null;
}

/**
 * InfoRow - Displays a label-value pair in a side panel
 *
 * A container wider than 36rem, such as the tablet detail page, spreads the
 * pair into a divided table row. Narrower, it stays a compact stacked pair.
 *
 * @example
 * ```tsx
 * <InfoRow label="Machine ID" value={machine.machineId} />
 * ```
 */
export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className='flex items-start gap-4 @[36rem]:py-3.5'>
      <span
        className='size-p2 text-secondary w-32 shrink-0 wrap-break-word
          @[30rem]:w-52'
      >
        {label}
      </span>
      <span className='size-p2 text-primary min-w-0 flex-1 wrap-break-word'>
        {value || <span className='text-tertiary'>-</span>}
      </span>
    </div>
  );
}
